import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Text, RadioGroup, Flex, Checkbox, Radio, Stack } from '@chakra-ui/react';
import { NumericFormat } from 'react-number-format';
import { InputText } from '../Input';
import QuestionCard from './QuestionCard';
import { AttachmentButton } from '../Button';
import EvidenceViewerModal from '../Modals/EvidenceViewerModal';

const CertificationSurvey = ({
 surveyId,
 questions,
 defaultValues,
 userId,
 companyId,
 isViewMode = true,
}) => {
 const [attachEvidenceIsOpen, setAttachEvidenceIsOpen] = useState(false);
 const [currentQuestionName, setCurrentQuestionName] = useState();
 const [currentQuestion, setCurrentQuestion] = useState();

 const { register, control, handleSubmit } = useForm({
  defaultValues,
 });

 const onSubmit = async (data) => {
  if (isViewMode) return;
 };

 const handleModal = (questionName, question) => {
  setCurrentQuestionName(questionName);
  setCurrentQuestion(question);
  setAttachEvidenceIsOpen(true);
 };

 const closeModal = () => {
  setAttachEvidenceIsOpen(false);
  setCurrentQuestionName(undefined);
  setCurrentQuestion(undefined);
 };

 return (
  <>
   {currentQuestionName && currentQuestion && (
    <EvidenceViewerModal
     isOpen={attachEvidenceIsOpen}
     onClose={closeModal}
     control={control}
     currentQuestionName={currentQuestionName}
    />
   )}

   <form onSubmit={handleSubmit(onSubmit)}>
    <Stack spacing='4' mb={['20px', '40px']}>
     {questions?.map((question) => (
      <QuestionCard
       key={question?.id_question}
       question={question}
       surveyId={surveyId}
       userId={userId}
       companyId={companyId}
      >
       {question?.type === 'text' && (
        <InputText
         {...register(`text_question_${question.id_question}.value`)}
         type='text'
         w='400px'
         expandable
         isDisabled={isViewMode}
         isViewMode={isViewMode}
        />
       )}

       {question?.type === 'multiple_choice' && (
        <Flex gap='6' flexWrap='wrap'>
         {question?.options?.map((option, i) => (
          <Checkbox
           key={option?.id_question_option_template}
           value={option?.description}
           id={`checkbox_question_${question.id_question}_${option.id_question_option_template}_${i}`}
           {...register(`checkbox_question_${question.id_question}.value`)}
           className='regular-checkbox'
           isReadOnly={true}
          >
           <Text fontSize='sm' color='#5C6066'>
            {option?.description}
           </Text>
          </Checkbox>
         ))}
        </Flex>
       )}

       {question?.type === 'multi_choice' && (
        <RadioGroup
         defaultValue={
          defaultValues[`radio_question_${question?.id_question}`]?.value || ''
         }
         isDisabled={isViewMode}
        >
         <Flex gap='12px' flexWrap='wrap' className='questionary-app'>
          {question?.options?.map((option, i) => (
           <Radio
            key={option.id_question_option_template}
            id={`radio_question_${question.id_question}_${option?.id_question_option_template}_${i}`}
            {...register(`radio_question_${question?.id_question}.value`)}
            value={option.description}
           >
            {option?.description}
           </Radio>
          ))}
         </Flex>
        </RadioGroup>
       )}

       {question?.type === 'number' && (
        <InputText
         {...register(`number_question_${question.id_question}.value`, {
          pattern: /\S/,
         })}
         type='number'
         w='400px'
         isDisabled={isViewMode}
         isViewMode={isViewMode}
        />
       )}

       {question?.type === 'money' && (
        <Flex w='400px'>
         <Controller
          name={`money_question_${question?.id_question}.value`}
          control={control}
          render={({ field: { ref, ...rest } }) => (
           <NumericFormat
            displayType='input'
            thousandSeparator=','
            decimalSeparator='.'
            prefix='R$ '
            decimalScale={3}
            getInputRef={ref}
            min={0}
            customInput={InputText}
            isDisabled={isViewMode}
            isViewMode={isViewMode}
            {...rest}
           />
          )}
         />
        </Flex>
       )}

       {question?.type === 'percentage' && (
        <Flex w='400px'>
         <Controller
          name={`percentage_question_${question.id_question}.value`}
          control={control}
          render={({ field: { ref, onChange, ...rest } }) => (
           <NumericFormat
            suffix='%'
            displayType='input'
            maxLength={4}
            fixedDecimalScale
            onValueChange={(values) => {
             const { value } = values;
             const numericValue = parseInt(value, 10);
             if (isNaN(numericValue)) {
              onChange(value);
             } else if (numericValue <= 100) {
              onChange(value);
             } else {
              onChange('100');
             }
            }}
            getInputRef={ref}
            customInput={InputText}
            isDisabled={isViewMode}
            isViewMode={isViewMode}
            {...rest}
           />
          )}
         />
        </Flex>
       )}

       <AttachmentButton
        control={control}
        question={question}
        handleModal={handleModal}
       />
      </QuestionCard>
     ))}
    </Stack>

    {/* {!isViewMode && (
          <SubmitButton isDisabled={!isDirty} isLoading={isSubmitting} />
        )} */}
   </form>
  </>
 );
};

export default CertificationSurvey;
